// Storefront — Arabic (RTL). Keys are the English source text.
export default {
  // Header, footer, navigation
  "Vehicle-checked parts": "قطع مطابقة لسيارتك",
  "from verified sellers": "من بائعين موثّقين",
  "Compare listings · Seller trust badges": "قارن العروض · شارات ثقة البائعين",
  "Can't find it? Sellers reply to part requests": "لم تجدها؟ البائعون يردّون على طلبات القطع",
  "Track order": "تتبّع الطلب",
  "PartHub home": "الصفحة الرئيسية لـ PartHub",
  "OEM · aftermarket · used": "أصلية · بديلة · مستعملة",
  "Search parts": "ابحث عن قطع",
  "Part name, SKU or OEM number…": "اسم القطعة أو SKU أو الرقم الأصلي OEM…",
  "Search": "بحث",
  "Your vehicle": "سيارتك",
  "No vehicle": "لا توجد سيارة",
  "Select vehicle": "اختر سيارتك",
  "Signed in": "مسجّل الدخول",
  "Hello, sign in": "مرحباً، سجّل الدخول",
  "Account": "الحساب",
  "Open cart, 1 item": "فتح السلة، قطعة واحدة",
  "Open cart, {n} items": "فتح السلة، {n} قطع",
  "Cart": "السلة",
  "Categories": "الأصناف",
  "Quick navigation": "تنقّل سريع",
  "Language": "اللغة",
  "All Categories": "كل الأصناف",
  "Brakes & Suspension": "الفرامل والتعليق",
  "Engine & Filters": "المحرك والفلاتر",
  "Electrical & Lighting": "الكهرباء والإنارة",
  "Transmission": "ناقل الحركة",
  "Exhaust": "العادم",
  "Fluids & Oils": "السوائل والزيوت",
  "Request a part": "اطلب قطعة",
  "Home": "الرئيسية",
  "Parts": "القطع",
  "Garage": "المرآب",
  "Request": "اطلب",
  "The trusted marketplace for OEM and aftermarket auto parts. Search by vehicle, compare listings, and buy from sellers with clearer trust signals.":
    "السوق الموثوق لقطع غيار السيارات الأصلية والبديلة. ابحث حسب سيارتك، قارن العروض، واشترِ من بائعين بمؤشرات ثقة واضحة.",
  "Shop": "تسوّق",
  "Browse All Parts": "كل القطع",
  "Shop by Vehicle": "تسوّق حسب السيارة",
  "OEM Parts": "قطع أصلية",
  "Compare Parts": "قارن القطع",
  "Sign In / Register": "دخول / تسجيل",
  "My Orders": "طلباتي",
  "My Garage": "مرآبي",
  "Saved Compare": "المقارنات المحفوظة",
  "My Account": "حسابي",
  "Support": "الدعم",
  "Track My Order": "تتبّع طلبي",
  "Order Confirmation": "تأكيد الطلب",
  "Seller Center": "مركز البائعين",
  "Contact Support": "اتصل بالدعم",
  "Help Center": "مركز المساعدة",
  "© 2026 PartHub Inc. All rights reserved.": "© 2026 PartHub. جميع الحقوق محفوظة.",

  // Cart drawer & cart page
  "1 item": "قطعة واحدة",
  "{n} items": "{n} قطع",
  "Your cart": "سلّتك",
  "Close cart": "إغلاق السلة",
  "Your cart is empty": "سلّتك فارغة",
  "Your cart is empty.": "سلّتك فارغة.",
  "Browse parts for your {vehicle}.": "تصفّح القطع المناسبة لـ {vehicle}.",
  "Select your vehicle first so you only see parts that fit.": "اختر سيارتك أولاً لترى القطع المناسبة لها فقط.",
  "Browse parts": "تصفّح القطع",
  "Shopping for": "تتسوّق لـ",
  ". Check the fitment on each part's page, or confirm the OEM number with the seller.":
    ". تحقّق من التوافق في صفحة كل قطعة، أو أكّد الرقم الأصلي OEM مع البائع.",
  "No vehicle selected, so fitment hasn't been checked.": "لم تختر سيارة، لذلك لم يتم التحقق من التوافق.",
  "Select your vehicle": "اختر سيارتك",
  "Sold by {seller}": "يبيعها {seller}",
  "Quantity for {title}": "الكمية لـ {title}",
  "Decrease quantity": "إنقاص الكمية",
  "Increase quantity": "زيادة الكمية",
  "{price} each": "{price} للقطعة",
  "Remove": "حذف",
  "Subtotal": "المجموع الفرعي",
  "Shipping": "التوصيل",
  "Calculated at checkout": "يُحسب عند إتمام الطلب",
  "Checkout ·": "إتمام الطلب ·",
  "View full cart": "عرض السلة كاملة",
  "Review selected parts before checkout.": "راجع القطع قبل إتمام الطلب.",
  "Browse the marketplace and add parts to continue.": "تصفّح السوق وأضف قطعاً للمتابعة.",
  "Review selected parts and continue to checkout.": "راجع القطع ثم تابع لإتمام الطلب.",
  "Checkout context includes your selected vehicle:": "سيُرفق الطلب بسيارتك المختارة:",
  "No vehicle selected. You can still checkout, but fitment confirmation is stronger when a vehicle is selected.":
    "لم تختر سيارة. يمكنك إتمام الطلب، لكن التحقق من التوافق أدق عند اختيار السيارة.",
  "Seller: {seller}": "البائع: {seller}",
  "Estimated total": "المجموع التقديري",
  "Continue to checkout": "متابعة لإتمام الطلب",
  "Clear cart": "إفراغ السلة",
  "Sign in at checkout to track your order. Final fitment confirmation should still rely on SKU, OEM reference, and seller guidance.":
    "سجّل الدخول عند إتمام الطلب لتتبّعه. التأكيد النهائي للتوافق يعتمد على SKU والرقم الأصلي وتوجيه البائع.",

  // Checkout
  "Full name is required.": "الاسم الكامل مطلوب.",
  "Phone number is required.": "رقم الهاتف مطلوب.",
  "Address line 1 is required.": "العنوان مطلوب.",
  "City is required.": "المدينة مطلوبة.",
  "Order placed successfully.": "تم تسجيل الطلب بنجاح.",
  "Failed to place order": "تعذّر تسجيل الطلب",
  "Add parts to your cart before proceeding to checkout.": "أضف قطعاً إلى سلّتك قبل إتمام الطلب.",
  "Sign in to check out": "سجّل الدخول لإتمام الطلب",
  "Your cart is saved. Sign in or create a free account so you can track the order and the seller can reach you.":
    "سلّتك محفوظة. سجّل الدخول أو أنشئ حساباً مجانياً لتتبّع الطلب وليتمكّن البائع من التواصل معك.",
  "Sign in to continue": "سجّل الدخول للمتابعة",
  "Checkout": "إتمام الطلب",
  "Confirm your delivery details. Sellers may call to confirm fitment before shipping.":
    "أكّد معلومات التوصيل. قد يتصل بك البائع لتأكيد التوافق قبل الشحن.",
  "Your selected vehicle will be attached as checkout context:": "ستُرفق سيارتك المختارة بالطلب:",
  "No vehicle selected. You can still place the order, but fitment confidence is stronger when a vehicle is selected.":
    "لم تختر سيارة. يمكنك تسجيل الطلب، لكن التوافق يكون أوثق عند اختيار السيارة.",
  "Delivery details": "معلومات التوصيل",
  "Where should the seller deliver your parts?": "أين يوصل البائع قطعك؟",
  "Full name": "الاسم الكامل",
  "Email (optional)": "البريد الإلكتروني (اختياري)",
  "Phone": "الهاتف",
  "Address line 1": "العنوان",
  "Street address": "الشارع والرقم",
  "Address line 2 (optional)": "تكملة العنوان (اختياري)",
  "Apartment, suite, etc.": "الشقة، الطابق، إلخ.",
  "City": "المدينة",
  "Casablanca": "الدار البيضاء",
  "State / Region": "الجهة",
  "Casablanca-Settat": "الدار البيضاء-سطات",
  "Postal code": "الرمز البريدي",
  "Country": "البلد",
  "Order notes (optional)": "ملاحظات الطلب (اختياري)",
  "Add delivery notes or fitment confirmation requests...": "أضف ملاحظات للتوصيل أو طلب تأكيد التوافق…",
  "Placing order...": "جارٍ تسجيل الطلب…",
  "Place order": "تأكيد الطلب",
  "Order summary": "ملخّص الطلب",
  "Items": "القطع",
  "Delivery (flat rate)": "التوصيل (سعر ثابت)",
  "Total": "المجموع",
  "Final fitment confirmation should still rely on SKU, OEM reference, and seller confirmation where needed.":
    "التأكيد النهائي للتوافق يعتمد على SKU والرقم الأصلي وتأكيد البائع عند الحاجة.",
  "Checkout trust": "اطلب بثقة",
  "• Your order appears in your account with a tracking reference.": "• يظهر طلبك في حسابك مع رقم تتبّع.",
  "• Vehicle context is attached when selected.": "• تُرفق سيارتك بالطلب عند اختيارها.",
  "• Seller follow-up can still confirm final fitment before fulfillment.": "• يمكن للبائع تأكيد التوافق قبل الشحن.",
  "• SKU and notes remain important for high-confidence orders.": "• يبقى SKU والملاحظات مهمّين لطلب مضمون.",
  "Verified": "موثّق",

  // Checkout success
  "Hello, I just placed an order on PartHub.": "مرحباً، قمت للتو بطلب على PartHub.",
  "Order ID: {id}": "رقم الطلب: {id}",
  "Vehicle: {vehicle}": "السيارة: {vehicle}",
  "I would like to confirm the next steps and fitment context.": "أودّ تأكيد الخطوات التالية وتوافق القطعة.",
  "Order received": "تم استلام الطلب",
  "Your order has been placed": "تم تسجيل طلبك",
  "Thank you. Your request is now recorded and the seller can review the order details.":
    "شكراً لك. تم تسجيل طلبك ويمكن للبائع الآن مراجعة تفاصيله.",
  "What happens next": "ماذا بعد؟",
  "1. Seller reviews the order": "1. البائع يراجع الطلب",
  "The seller checks availability, fitment context, and order details.": "يتحقّق البائع من التوفر والتوافق وتفاصيل الطلب.",
  "2. Fitment may be reconfirmed": "2. قد يُعاد تأكيد التوافق",
  "SKU, OEM reference, and seller notes may still be used to confirm final compatibility.":
    "قد يُستعمل SKU والرقم الأصلي وملاحظات البائع لتأكيد التوافق النهائي.",
  "3. Delivery and payment follow-up": "3. التوصيل والدفع",
  "Shipping timing and final fulfillment steps are handled after seller confirmation.":
    "يُحدَّد موعد الشحن والخطوات النهائية بعد تأكيد البائع.",
  "Continue browsing": "متابعة التسوّق",
  "Confirm on WhatsApp": "التأكيد عبر واتساب",
  "Order reference": "مرجع الطلب",
  "Generated successfully": "تم إنشاؤه بنجاح",
  "Checkout type": "نوع الطلب",
  "Guest checkout": "طلب كزائر",
  "Vehicle context": "السيارة",
  "Not attached": "غير مرفقة",
  "Keep your SKU references and fitment notes nearby in case the seller asks for confirmation.":
    "احتفظ بأرقام SKU وملاحظات التوافق في حال طلب البائع التأكيد.",
  "Buyer advice": "نصائح للمشتري",
  "• Save your vehicle in the garage for faster future searches.": "• احفظ سيارتك في المرآب لبحث أسرع لاحقاً.",
  "• Use WhatsApp if you need confirmation before shipping.": "• استعمل واتساب إن احتجت تأكيداً قبل الشحن.",
  "• Keep part SKU and vehicle year ready for follow-up.": "• جهّز SKU القطعة وسنة السيارة للمتابعة.",

  // Home
  "Engine": "المحرك",
  "Brakes": "الفرامل",
  "Electrical": "الكهرباء",
  "Filters": "الفلاتر",
  "Suspension": "التعليق",
  "Lighting": "الإنارة",
  "Flash Deals": "عروض سريعة",
  "✓ 2.4M+ Parts · 1,200+ Verified Sellers": "✓ أكثر من 2.4 مليون قطعة · أكثر من 1200 بائع موثّق",
  "Find the Right Part,": "اعثر على القطعة المناسبة،",
  "Every Time": "في كل مرة",
  "Search by vehicle, part name, OEM number, or VIN. Use Garage context and trust signals to reach the right listing faster.":
    "ابحث حسب السيارة أو اسم القطعة أو الرقم الأصلي OEM أو رقم الهيكل VIN. مرآبك ومؤشرات الثقة توصلك للعرض المناسب أسرع.",
  "By Vehicle": "حسب السيارة",
  "By Part Name": "حسب اسم القطعة",
  "OEM / Part #": "الرقم الأصلي / رقم القطعة",
  "By VIN": "حسب رقم الهيكل",
  "Year": "السنة",
  "Select Year": "اختر السنة",
  "Make": "العلامة",
  "Select Make": "اختر العلامة",
  "Model": "الطراز",
  "Select Model": "اختر الطراز",
  "Open Garage": "افتح المرآب",
  "Search Compatible Parts": "ابحث عن القطع المتوافقة",
  "Change Vehicle": "غيّر السيارة",
  "e.g. front brake pads, oil filter, alternator…": "مثلاً: فحمات الفرامل الأمامية، فلتر الزيت، الدينامو…",
  "Search Parts": "ابحث",
  "e.g. 90915-YZZD2, 04152-YZZA4…": "مثلاً: 90915-YZZD2، 04152-YZZA4…",
  "Look Up Part Number": "ابحث بالرقم",
  "17-character VIN": "رقم هيكل من 17 حرفاً",
  "Find Parts by VIN": "ابحث برقم الهيكل",
  "Popular:": "الأكثر طلباً:",
  "Brake Pads": "فحمات الفرامل",
  "Oil Filter": "فلتر الزيت",
  "Spark Plugs": "شمعات الإشعال",
  "Alternator": "الدينامو",
  "Shock Absorbers": "مخمّدات الصدمات",
  "Parts in catalog": "قطعة في الكتالوج",
  "Verified sellers": "بائع موثّق",
  "Average buyer rating": "متوسط تقييم المشترين",
  "Browse categories": "تصفّح الأصناف",
  "Start from a common parts family": "ابدأ من صنف شائع",
  "See all": "عرض الكل",
  "Featured discovery": "اكتشف",
  "High-intent starting points for buyers": "أكثر عمليات البحث طلباً",
  "View all": "عرض الكل",
  "Front Brake Pads Kit": "طقم فحمات فرامل أمامية",
  "Vehicle compatibility added": "التوافق مع السيارات مضاف",
  "Sale": "تخفيض",
  "Performance Air Filter": "فلتر هواء عالي الأداء",
  "Popular vehicle match": "يناسب السيارات الشائعة",
  "New": "جديد",
  "Spark Plug Set": "طقم شمعات إشعال",
  "Garage-friendly search": "بحث حسب المرآب",
  "Rear Shock Absorber Pair": "زوج مخمّدات خلفية",
  "Compatibility-first listing": "عرض مع بيانات التوافق",
  "Top verified sellers": "أفضل البائعين الموثّقين",
  "Seller trust and storefront discovery": "بائعون موثوقون ومتاجرهم",
  "Why PartHub": "لماذا PartHub",
  "The cleaner buyer journey": "تجربة شراء أبسط",
  "Fitment-first discovery, verified sellers, tracked orders, and support-oriented flows.":
    "بحث حسب التوافق، بائعون موثّقون، طلبات قابلة للتتبّع، ودعم متواصل.",
  "Vehicle Compatibility Check": "التحقق من التوافق",
  "Filter discovery by your exact year, make, model, and engine context.": "صفِّ النتائج حسب سنة سيارتك وعلامتها وطرازها ومحركها.",
  "Verified Sellers": "بائعون موثّقون",
  "Seller trust signals and public storefront access improve buyer confidence.": "مؤشرات الثقة والمتاجر العامة تمنحك اطمئناناً أكبر.",
  "Fast Shipping Flow": "طلب سريع",
  "Cart, checkout, order history, and tracking pages already exist in the storefront.": "السلة وإتمام الطلب وسجلّ الطلبات والتتبّع في مكان واحد.",
  "Compare Before You Buy": "قارن قبل الشراء",
  "Compare shortlisted parts before opening details or moving to checkout.": "قارن القطع المفضّلة قبل إتمام الطلب.",

  // Parts for your vehicle
  "Your garage": "مرآبك",
  "Parts for your {vehicle}": "قطع لسيارتك {vehicle}",
  "Listings with compatibility data for this vehicle.": "عروض ببيانات توافق مع هذه السيارة.",
  "See all {n}": "عرض الكل ({n})",
  "No parts are listed for your {vehicle} yet.": "لا توجد قطع معروضة لـ {vehicle} بعد.",
  "Send a request and sellers who stock {make} parts can reply with offers.":
    "أرسل طلباً وسيردّ عليك البائعون الذين يملكون قطع {make} بعروضهم.",
  "Browse all parts": "تصفّح كل القطع",
  "Fits your {vehicle}": "تناسب {vehicle}",
  "Fits your vehicle": "تناسب سيارتك",
  "Unbranded": "بدون علامة",

  // Parts list
  "Try a broader keyword than \"{q}\".": "جرّب كلمة أعمّ من «{q}».",
  "Try searching by part name, SKU, or brand.": "جرّب البحث باسم القطعة أو SKU أو العلامة.",
  "Your current vehicle filter is {vehicle}.": "فلتر السيارة الحالي: {vehicle}.",
  "Clear the vehicle context to see a wider catalog.": "أزل السيارة لرؤية كتالوج أوسع.",
  "Try removing the category filter.": "جرّب إزالة فلتر الصنف.",
  "Try removing the brand filter.": "جرّب إزالة فلتر العلامة.",
  "Try switching condition or removing it.": "جرّب تغيير فلتر الحالة أو إزالته.",
  "Exact fit": "متوافقة",
  "Vehicle match": "تطابق السيارة",
  "Strong compatibility": "توافق قوي",
  "Compatibility added": "التوافق مضاف",
  "Featured": "مميّزة",
  "Low stock": "مخزون قليل",
  "Fitment-ready seller": "بائع يضيف التوافق",
  "Well stocked": "مخزون جيد",
  "Trusted seller": "بائع موثوق",
  "Used": "مستعملة",
  "Aftermarket": "بديلة",
  "Failed to load parts": "تعذّر تحميل القطع",
  "Search: {q}": "بحث: {q}",
  "Filtered marketplace search": "بحث مُصفّى",
  "Loading parts...": "جارٍ تحميل القطع…",
  "1 result found": "نتيجة واحدة",
  "{n} results found": "{n} نتيجة",
  "{n} results": "{n} نتيجة",
  "Search by title, SKU, keyword...": "العنوان، SKU، كلمة مفتاحية…",
  "All categories": "كل الأصناف",
  "All brands": "كل العلامات",
  "All conditions": "كل الحالات",
  "Refurbished": "مُجدّدة",
  "Min price": "أدنى سعر",
  "Max price": "أعلى سعر",
  "Sort": "الترتيب",
  "Relevance": "الأكثر صلة",
  "Newest": "الأحدث",
  "Price: Low to high": "السعر: من الأقل للأعلى",
  "Price: High to low": "السعر: من الأعلى للأقل",
  "Clear filters": "مسح الفلاتر",
  "Clear vehicle": "إزالة السيارة",
  "Vehicle-aware parts search": "بحث حسب سيارتك",
  "Find the right part faster": "اعثر على القطعة المناسبة أسرع",
  "Search listings by keyword, brand, category, and your selected vehicle context.":
    "ابحث بالكلمة أو العلامة أو الصنف وحسب سيارتك المختارة.",
  "Selected vehicle:": "السيارة المختارة:",
  "Clear": "مسح",
  "No vehicle selected. Search still works, but ranking is stronger with a vehicle selected.":
    "لم تختر سيارة. البحث يعمل، لكن الترتيب أدق عند اختيار السيارة.",
  "Save search": "حفظ البحث",
  "Reset search": "إعادة ضبط البحث",
  "Refine results for faster matching.": "دقّق النتائج.",
  "Loading filters...": "جارٍ تحميل الفلاتر…",
  "Showing broader marketplace results": "نتائج من كل السوق",
  "1 exact match for {vehicle}": "قطعة واحدة متوافقة مع {vehicle}",
  "{n} exact matches for {vehicle}": "{n} قطعة متوافقة مع {vehicle}",
  "Only parts that fit my {vehicle}": "القطع المناسبة لـ {vehicle} فقط",
  "Save this search": "احفظ هذا البحث",
  "Vehicle-aware": "حسب السيارة",
  "Exact matches": "متوافقة",
  "Broader fitment candidates": "قطع محتملة أخرى",
  "Select your vehicle to unlock exact fitment ranking and stronger part matching.":
    "اختر سيارتك لترتيب القطع حسب التوافق.",
  "Top result": "أفضل نتيجة",
  "Brand unavailable": "العلامة غير معروفة",
  "View best match": "عرض أفضل قطعة",
  "Remove from shortlist": "إزالة من المفضّلة",
  "Add to shortlist": "إضافة إلى المفضّلة",
  "No exact matches found for your selected vehicle": "لا توجد قطع متوافقة مع سيارتك",
  "No parts found": "لا توجد قطع",
  "No listings matched your current vehicle and filter combination.": "لا توجد عروض تطابق سيارتك والفلاتر الحالية.",
  "No listings matched your current search and filter combination.": "لا توجد عروض تطابق بحثك والفلاتر الحالية.",
  "Show all parts, best fit first": "عرض كل القطع، الأنسب أولاً",
  "Reset search filters": "إعادة ضبط الفلاتر",
  "Can't find it? Request this part": "لم تجدها؟ اطلب هذه القطعة",
  "Clear vehicle filter": "إزالة فلتر السيارة",
  "SKU": "SKU",
  "Seller": "البائع",
  "Low stock · {n} left": "مخزون قليل · بقي {n}",
  "In stock · {n}": "متوفّرة · {n}",
  "Same model, check the year": "نفس الطراز، تحقّق من السنة",
  "Fits 1 vehicle setup": "تناسب طرازاً واحداً",
  "Fits {n} vehicle setups": "تناسب {n} طرازات",
  "No fitment data yet": "لا توجد بيانات توافق بعد",
  "Shortlisted": "في المفضّلة",
  "Shortlist": "المفضّلة",
  "Add more": "أضف المزيد",
  "Add to Cart": "أضف إلى السلة",
  "Sold out": "نفدت",
  "Previous": "السابق",
  "Next": "التالي",
  "1 saved part": "قطعة محفوظة واحدة",
  "{n} saved parts": "{n} قطع محفوظة",
  "Compare": "قارن",
  "View": "عرض",
  "Refine marketplace results": "تدقيق النتائج",
  "Close": "إغلاق",

  // Part details
  "Part image": "صورة القطعة",
  "Brand": "العلامة",
  "Category": "الصنف",
  "Condition": "الحالة",
  "Location": "الموقع",
  "Weight": "الوزن",
  "Select your vehicle to confirm fitment": "اختر سيارتك للتأكد من التوافق",
  "Choose make, model, and year to verify whether this part matches your vehicle.":
    "اختر العلامة والطراز والسنة للتأكد أن القطعة تناسب سيارتك.",
  "This part has a compatibility row that matches your selected vehicle.": "هذه القطعة مسجّلة كمتوافقة مع سيارتك المختارة.",
  "Compatibility not confirmed for your vehicle": "التوافق مع سيارتك غير مؤكَّد",
  "This part includes compatibility data, but your selected vehicle is not an exact confirmed match.":
    "لهذه القطعة بيانات توافق، لكن سيارتك ليست ضمنها بشكل مؤكَّد.",
  "No structured compatibility data yet": "لا توجد بيانات توافق بعد",
  "Use SKU, seller notes, and product details until compatibility data is expanded.":
    "اعتمد على SKU وملاحظات البائع ووصف القطعة إلى حين إضافة بيانات التوافق.",
  "No vehicle selected": "لم تختر سيارة",
  "Hello, I want to confirm this part.": "مرحباً، أريد التأكد من هذه القطعة.",
  "Part: {title}": "القطعة: {title}",
  "Unknown part": "قطعة غير معروفة",
  "Failed to load part details": "تعذّر تحميل تفاصيل القطعة",
  "Loading part details...": "جارٍ تحميل تفاصيل القطعة…",
  "Part not found": "القطعة غير موجودة",
  "No image available": "لا توجد صورة",
  "Stock status": "المخزون",
  "{n} available": "{n} متوفّرة",
  "Out of stock": "غير متوفّرة",
  "Compatibility": "التوافق",
  "Vehicle-matched": "متوافقة مع السيارة",
  "No description available for this part yet.": "لا يوجد وصف لهذه القطعة بعد.",
  "In stock ({n})": "متوفّرة ({n})",
  "Unknown seller": "بائع غير معروف",
  "1 compatibility row": "توافق واحد",
  "{n} compatibility rows": "{n} توافقات",
  "Exact match confirmed": "التوافق مؤكَّد",
  "Save vehicle": "احفظ السيارة",
  "Final purchase confidence should still confirm SKU, OEM reference, and seller guidance.":
    "قبل الشراء، أكّد SKU والرقم الأصلي ورأي البائع.",
  "Adding...": "جارٍ الإضافة…",
  "Added to cart": "أُضيفت إلى السلة",
  "Add to cart": "أضف إلى السلة",
  "Ask seller on WhatsApp": "اسأل البائع عبر واتساب",
  "Why buyers trust this listing": "لماذا يثق المشترون بهذا العرض",
  "• SKU and structured compatibility improve confidence before purchase.": "• SKU وبيانات التوافق تمنحك ثقة قبل الشراء.",
  "• Stock visibility helps reduce surprise checkout failures.": "• عرض المخزون يجنّبك المفاجآت عند الطلب.",
  "• Seller contact via WhatsApp makes pre-purchase confirmation easier.": "• التواصل عبر واتساب يسهّل التأكد قبل الشراء.",
  "• Vehicle-aware matching helps rank the most relevant parts higher.": "• الترتيب حسب السيارة يُظهر القطع الأنسب أولاً.",
  "Seller trust": "ثقة البائع",
  "Seller:": "البائع:",
  "Unknown": "غير معروف",
  "Location:": "الموقع:",
  "Not specified": "غير محدّد",
  "Listing status:": "حالة العرض:",
  "Availability:": "التوفّر:",
  "{n} unit(s) available": "{n} قطعة متوفّرة",
  "Currently unavailable": "غير متوفّرة حالياً",
  "SKU:": "SKU:",
  "Strong parts usually include stock, SKU, compatibility, and easy seller confirmation paths.":
    "العرض الجيد يتضمّن المخزون وSKU والتوافق وطريقة سهلة للتواصل مع البائع.",
  "Quick fitment summary": "ملخّص التوافق",
  "Selected vehicle": "السيارة المختارة",
  "Not selected": "غير مختارة",
  "Compatibility rows": "التوافقات",
  "Match status": "حالة التطابق",
  "Confirmed match": "متوافقة",
  "Not confirmed": "غير مؤكَّد",
  "Review all known vehicle matches for this part.": "كل السيارات المعروفة المتوافقة مع هذه القطعة.",
  "No compatibility rows are available yet for this part.": "لا توجد توافقات مسجّلة لهذه القطعة بعد.",
  "Your selected vehicle matches": "سيارتك متوافقة",
  "Specifications": "المواصفات",
  "No technical specifications available yet.": "لا توجد مواصفات تقنية بعد.",
  "Purchase reassurance": "اشترِ باطمئنان",
  "• Confirm exact fitment when your vehicle has engine or trim variations.": "• أكّد التوافق إن كانت لسيارتك عدة محركات أو فئات.",
  "• Use seller contact before checkout if you need additional confidence.": "• تواصل مع البائع قبل الطلب إن كان لديك شك.",
  "• SKU and compatibility rows are stronger trust signals than title alone.": "• SKU والتوافق أوثق من العنوان وحده.",
  "• In-stock parts with structured fitment usually move faster and convert better.": "• القطع المتوفّرة ببيانات توافق تُباع أسرع.",
  "Need another option?": "تحتاج خياراً آخر؟",
  "Explore related parts from the marketplace inventory.": "اكتشف قطعاً مشابهة.",
  "No related parts available yet.": "لا توجد قطع مشابهة بعد.",
  "No image": "لا صورة",
  "Match": "متوافقة",
  "Added": "أُضيفت",

  // Auth
  "Please enter your email and password.": "أدخل بريدك الإلكتروني وكلمة المرور.",
  "Please enter your full name.": "أدخل اسمك الكامل.",
  "Account created successfully. Please sign in.": "تم إنشاء الحساب. يمكنك تسجيل الدخول الآن.",
  "Authentication failed.": "فشل تسجيل الدخول.",
  "Buyer account": "حساب مشترٍ",
  "You are already signed in": "أنت مسجّل الدخول بالفعل",
  "Continue to your account, orders, checkout, or return to the catalog.": "تابع إلى حسابك أو طلباتك، أو عد إلى الكتالوج.",
  "Signed-in session": "الجلسة الحالية",
  "Email": "البريد الإلكتروني",
  "Cart items": "قطع في السلة",
  "Continue": "متابعة",
  "Go to account": "إلى حسابي",
  "Buyer auth foundation": "فضاء المشتري",
  "Create your buyer account": "أنشئ حساب المشتري",
  "Access your buyer session for account, orders, cart, and checkout flow.": "ادخل إلى حسابك وطلباتك وسلّتك وإتمام الطلب.",
  "Create a buyer account to prepare a smoother storefront and checkout experience.": "أنشئ حساب مشترٍ لتطلب بسهولة أكبر.",
  "✔ Buyer-only storefront auth": "✔ حساب خاص بالمشترين",
  "✔ Session-ready checkout flow": "✔ إتمام طلب أسرع",
  "Why sign in?": "لماذا تسجّل الدخول؟",
  "Continue more smoothly from cart to checkout.": "انتقل من السلة إلى الطلب بسلاسة.",
  "Prepare access to buyer account and order history foundation.": "اطّلع على حسابك وسجلّ طلباتك.",
  "Keep the storefront flow cleaner across future sessions.": "تجد معلوماتك في كل زيارة.",
  "Current storefront state": "الحالة الحالية",
  "Post-login redirect": "بعد تسجيل الدخول",
  "Back to cart": "العودة إلى السلة",
  "Sign in": "تسجيل الدخول",
  "Create account": "إنشاء حساب",
  "Buyer sign in": "دخول المشتري",
  "Buyer registration": "تسجيل مشترٍ جديد",
  "Enter your email and password to continue.": "أدخل بريدك الإلكتروني وكلمة المرور للمتابعة.",
  "Create your buyer account with basic details.": "أنشئ حسابك ببضع معلومات.",
  "Password": "كلمة المرور",
  "Please wait...": "يرجى الانتظار…",
  "Create buyer account": "إنشاء حسابي",
  "Don’t have an account?": "ليس لديك حساب؟",
  "Create one": "أنشئ حساباً",
  "Already have an account?": "لديك حساب؟",

  // Garage, vehicle bar, saved searches, 404
  "Select and save a vehicle to unlock faster fitment-aware shopping.": "اختر سيارة واحفظها لتجد القطع المتوافقة أسرع.",
  "No active vehicle selected": "لا توجد سيارة نشطة",
  "My garage": "مرآبي",
  "Save vehicles and switch fitment context instantly.": "احفظ سياراتك وبدّل بينها بسرعة.",
  "Save current": "احفظ الحالية",
  "Active vehicle": "السيارة النشطة",
  "Save to garage": "احفظ في المرآب",
  "No active vehicle selected yet.": "لا توجد سيارة نشطة بعد.",
  "No saved vehicles yet.": "لا توجد سيارات محفوظة.",
  "Currently active": "نشطة حالياً",
  "Saved in garage": "محفوظة في المرآب",
  "Use vehicle": "استعمل",
  "Saved searches": "عمليات البحث المحفوظة",
  "Save important searches and return to them quickly.": "احفظ عمليات بحثك وعد إليها بسرعة.",
  "No saved searches yet.": "لا توجد عمليات بحث محفوظة.",
  "Re-open saved buyer intent in one click.": "أعد فتح بحث محفوظ بنقرة واحدة.",
  "Saved search": "بحث محفوظ",
  "No keyword": "بدون كلمة",
  "Open": "فتح",
  "Open in page": "فتح في الصفحة",
  "Page Not Found": "الصفحة غير موجودة",
  "The page you're looking for doesn't exist.": "الصفحة التي تبحث عنها غير موجودة.",
  "Back to Home": "العودة إلى الرئيسية",

  // Category names from the catalog (falls back to the stored name).
  "Body": "الهيكل",
  "Cooling": "التبريد",
  "Interior": "الداخلية",
  "Steering": "المقود",
  "Wheels & Tyres": "العجلات والإطارات",
  "Batteries": "البطاريات",
  "Accessories": "الإكسسوارات",
  "Clutch": "القابض",

  // Phase 2: account, orders, tracking, compare, seller, vehicle selector, part requests
  "Basic listing": "عرض عادي",
  "Compare parts": "قارن القطع",
  "Compare shortlisted parts side by side.": "قارن القطع المفضّلة جنباً إلى جنب.",
  "No parts selected for comparison": "لم تختر أي قطعة للمقارنة",
  "Add parts to shortlist from the search results first.": "أضف قطعاً إلى المفضّلة من نتائج البحث أولاً.",
  "Review price, stock, fitment depth, and seller quality side by side.": "قارن السعر والمخزون والتوافق والبائع جنباً إلى جنب.",
  "Clear compare": "مسح المقارنة",
  "Field": "المعيار",
  "Open part": "عرض القطعة",
  "Price": "السعر",
  "Stock": "المخزون",
  "{n} row(s)": "{n} توافق",
  "Fitment signal": "مؤشر التوافق",
  "High relevance": "ملاءمة عالية",
  "Standard": "عادي",
  "Hello, I accepted your offer on PartHub for \"{part}\" ({ref}).": "مرحباً، قبلت عرضك على PartHub لـ «{part}» ({ref}).",
  "Dismantler": "مفكّك سيارات (كاسة)",
  "Best price": "أفضل سعر",
  "{n} months warranty": "ضمان {n} أشهر",
  "No warranty": "بدون ضمان",
  "Available today": "متوفّرة اليوم",
  "Ready in {n} days": "جاهزة خلال {n} أيام",
  "You accepted this offer. Contact the seller to arrange the sale:": "قبلت هذا العرض. تواصل مع البائع لإتمام البيع:",
  "WhatsApp seller": "واتساب البائع",
  "Accepting…": "جارٍ القبول…",
  "Accept this offer": "اقبل هذا العرض",
  "Could not load this request": "تعذّر تحميل هذا الطلب",
  "Accept the offer from {seller} for {price}? Other offers will be declined.": "قبول عرض {seller} بسعر {price}؟ سيتم رفض العروض الأخرى.",
  "Could not accept this offer": "تعذّر قبول هذا العرض",
  "Close this request? Sellers won't be able to send more offers.": "إغلاق هذا الطلب؟ لن يتمكن البائعون من إرسال عروض أخرى.",
  "Could not close this request": "تعذّر إغلاق هذا الطلب",
  "Request not found": "الطلب غير موجود",
  "← Back to my requests": "→ العودة إلى طلباتي",
  "← My requests": "→ طلباتي",
  "Request sent!": "تم إرسال الطلب!",
  "Matching sellers can see it now. Come back here to compare their offers.": "البائعون المعنيّون يرونه الآن. عد إلى هنا لمقارنة عروضهم.",
  "OEM number": "الرقم الأصلي OEM",
  "Open until {date}": "مفتوح حتى {date}",
  "Close request": "أغلق الطلب",
  "Waiting for offers": "في انتظار العروض",
  "Sellers who stock parts for your {make} can see your request in their inbox.": "البائعون الذين يملكون قطع {make} يرون طلبك في صندوقهم.",
  "Offer accepted": "تم قبول عرض",
  "Closed": "مغلق",
  "Expired": "منتهي",
  "Open for offers": "مفتوح للعروض",
  "New or used": "جديدة أو مستعملة",
  "Active seller": "بائع نشط",
  "In stock": "متوفّرة",
  "Breaker": "كاسة",
  "Importer": "مستورد",
  "Parts Shop": "محل قطع غيار",
  "OEM Genuine": "أصلية",
  "Used Part": "قطعة مستعملة",
  "Failed to load seller profile": "تعذّر تحميل صفحة البائع",
  "Loading seller profile...": "جارٍ تحميل صفحة البائع…",
  "Seller not found": "البائع غير موجود",
  "Seller profile": "صفحة البائع",
  "Browse this seller’s active inventory and trust signals before purchase.": "تصفّح مخزون هذا البائع ومؤشرات ثقته قبل الشراء.",
  "1 active part": "قطعة نشطة واحدة",
  "{n} active parts": "{n} قطع نشطة",
  "About this seller": "عن هذا البائع",
  "Seller type:": "نوع البائع:",
  "Phone:": "الهاتف:",
  "Active listings:": "العروض النشطة:",
  "Fitment-ready listings:": "عروض ببيانات توافق:",
  "Seller description": "وصف البائع",
  "No seller description available yet.": "لا يوجد وصف للبائع بعد.",
  "Why this seller may be trusted": "لماذا يمكن الوثوق بهذا البائع",
  "• Active inventory indicates this seller is currently participating in the marketplace.": "• المخزون النشط يدل على أن البائع حاضر في السوق حالياً.",
  "• Fitment-ready listings usually reduce buyer hesitation and improve part matching.": "• العروض ببيانات توافق تسهّل اختيار القطعة الصحيحة.",
  "• Stock visibility and structured compatibility are stronger trust signals than title alone.": "• عرض المخزون وبيانات التوافق أوثق من العنوان وحده.",
  "Seller inventory": "مخزون البائع",
  "Active marketplace listings from this seller.": "العروض النشطة لهذا البائع.",
  "No active parts found for this seller.": "لا توجد قطع نشطة لهذا البائع.",
  "{n} in stock": "{n} متوفّرة",
  "View part": "عرض القطعة",
  "Could not load your requests": "تعذّر تحميل طلباتك",
  "Sign in to see your part requests": "سجّل الدخول لرؤية طلبات القطع",
  "My part requests": "طلبات القطع الخاصة بي",
  "Offers from sellers appear here as they come in.": "تظهر عروض البائعين هنا فور وصولها.",
  "+ New request": "+ طلب جديد",
  "No requests yet": "لا توجد طلبات بعد",
  "Looking for a part that isn't listed? Describe it once and sellers will reply with offers.": "تبحث عن قطعة غير معروضة؟ صِفها مرة واحدة وسيردّ البائعون بعروضهم.",
  "from {price}": "ابتداءً من {price}",
  "Orders foundation": "الطلبات",
  "Sign in to view your orders": "سجّل الدخول لرؤية طلباتك",
  "Buyer sign-in prepares access to order history and tracking entry points.": "تسجيل الدخول يتيح لك سجلّ الطلبات وتتبّعها.",
  "Recommended": "مُستحسن",
  "Continue to your orders area.": "تابع إلى طلباتك.",
  "Go to checkout": "إتمام الطلب",
  "Complete buyer details first.": "أكمل معلوماتك أولاً.",
  "Review cart": "مراجعة السلة",
  "You currently have {n} item(s).": "لديك {n} قطعة في السلة.",
  "Your orders": "طلباتك",
  "This storefront area is ready for buyer order history, status, and tracking integration.": "هنا تجد سجلّ طلباتك وحالتها وتتبّعها.",
  "Back to account": "العودة إلى الحساب",
  "Buyer orders area": "طلباتي",
  "Signed in as {email}.": "مسجّل الدخول باسم {email}.",
  "buyer": "مشترٍ",
  "No orders yet": "لا توجد طلبات بعد",
  "Once the real checkout submission flow is wired, completed orders can appear here.": "ستظهر طلباتك المكتملة هنا.",
  "Order flow status": "حالة الطلبات",
  "Buyer authentication foundation: ready.": "حساب المشتري: جاهز.",
  "Cart and checkout foundations: ready.": "السلة وإتمام الطلب: جاهزان.",
  "Real order history API integration: next backend-connected step.": "سجلّ الطلبات: قريباً.",
  "Quick actions": "إجراءات سريعة",
  "Failed to load vehicle makes": "تعذّر تحميل العلامات",
  "Failed to load vehicle models": "تعذّر تحميل الطرازات",
  "Failed to load vehicle years": "تعذّر تحميل السنوات",
  "Please choose make, model, and year.": "اختر العلامة والطراز والسنة.",
  "Vehicle Selector PRO MAX": "اختيار السيارة",
  "Choose your vehicle first": "اختر سيارتك أولاً",
  "Select make, model, and year to browse parts faster and improve fitment accuracy.": "اختر العلامة والطراز والسنة لتجد القطع المتوافقة أسرع.",
  "✔ 30 makes": "✔ 30 علامة",
  "✔ 150 models": "✔ 150 طرازاً",
  "✔ 3300 year entries": "✔ 3300 سنة",
  "Vehicle saved successfully.": "تم حفظ السيارة.",
  "Start with the make, then model, then year.": "ابدأ بالعلامة ثم الطراز ثم السنة.",
  "Loading makes...": "جارٍ تحميل العلامات…",
  "Select make": "اختر العلامة",
  "Choose make first": "اختر العلامة أولاً",
  "Loading models...": "جارٍ تحميل الطرازات…",
  "Select model": "اختر الطراز",
  "Choose model first": "اختر الطراز أولاً",
  "Loading years...": "جارٍ تحميل السنوات…",
  "Select year": "اختر السنة",
  "Current selection": "الاختيار الحالي",
  "Why this matters": "لماذا هذا مهم",
  "✔ Faster catalog browsing": "✔ تصفّح أسرع",
  "✔ Better fitment workflows": "✔ تحقق أفضل من التوافق",
  "✔ Stronger vehicle-specific search foundation": "✔ نتائج خاصة بسيارتك",
  "✔ Ready for VIN / plate lookup later": "✔ البحث برقم الهيكل أو اللوحة قريباً",
  "Your order has been captured in the storefront order flow.": "تم تسجيل طلبك.",
  "Review in progress": "قيد المراجعة",
  "Order details, buyer information, and part availability are being reviewed.": "تتم مراجعة التفاصيل ومعلوماتك وتوفّر القطع.",
  "Preparing dispatch": "تجهيز الشحن",
  "The order is being prepared for shipment or seller confirmation.": "يتم تجهيز الطلب للشحن أو لتأكيد البائع.",
  "Shipped": "تم الشحن",
  "Tracking and delivery progress will appear here once shipment is live.": "سيظهر التتبّع هنا بعد الشحن.",
  "Delivered": "تم التوصيل",
  "Final delivery confirmation will appear at the end of the order flow.": "سيظهر تأكيد التوصيل في النهاية.",
  "Tracking foundation": "التتبّع",
  "Sign in to access order tracking": "سجّل الدخول لتتبّع طلبك",
  "Buyer sign-in helps keep order tracking connected to account and orders flow.": "تسجيل الدخول يربط التتبّع بحسابك وطلباتك.",
  "Continue to tracking for order {order}.": "تابع لتتبّع الطلب {order}.",
  "Orders": "الطلبات",
  "Back to orders": "العودة إلى الطلبات",
  "Return to the buyer orders area.": "العودة إلى طلباتك.",
  "Open your buyer account foundation.": "افتح حساب المشتري.",
  "Track your order": "تتبّع طلبك",
  "This storefront page is ready for real shipment tracking, order status updates, and delivery milestones.": "تابع هنا حالة طلبك ومراحل توصيله.",
  "Tracking reference": "مرجع التتبّع",
  "Order number unavailable": "رقم الطلب غير متوفّر",
  "This is a storefront tracking foundation. Once the real order and shipment APIs are connected, the page can show live shipment status, courier updates, and estimated delivery.": "سيُضاف قريباً التتبّع المباشر (شركة التوصيل والموعد المتوقع) إلى هذه الصفحة.",
  "Order progress": "تقدّم الطلب",
  "Completed": "مكتمل",
  "Pending": "قيد الانتظار",
  "Tracking notes": "ملاحظات التتبّع",
  "Tracking becomes much more useful once real order submission and shipment APIs are connected.": "سيصبح التتبّع أدق بعد ربط شركات التوصيل.",
  "Buyer sign-in keeps tracking linked to account and order history.": "تسجيل الدخول يربط التتبّع بسجلّ طلباتك.",
  "Order number is already wired into the route structure for future backend integration.": "رقم الطلب مرتبط بالصفحة.",
  "Route readiness": "حالة الصفحة",
  "Route param": "المعامل",
  "Tracking state": "حالة التتبّع",
  "Foundation ready": "جاهز",
  "What comes next": "الخطوات القادمة",
  "Real order lookup by order number.": "البحث عن الطلب برقمه.",
  "Shipment carrier and tracking code integration.": "شركة التوصيل ورمز التتبّع.",
  "Buyer notifications and delivery milestone updates.": "إشعارات مراحل التوصيل.",
  "Describe the part": "صِف القطعة",
  "Your vehicle and the part you need. It's free.": "سيارتك والقطعة التي تحتاجها. مجاناً.",
  "Sellers reply": "البائعون يردّون",
  "Matching shops and casses send you their best offer.": "المحلات والكاسات المعنيّة ترسل لك أفضل عروضها.",
  "Pick the best offer": "اختر أفضل عرض",
  "Compare price, condition and warranty, then contact the seller.": "قارن السعر والحالة والضمان، ثم تواصل مع البائع.",
  "Could not send your request": "تعذّر إرسال طلبك",
  "Can't find your part? Let the sellers come to you.": "لم تجد قطعتك؟ دع البائعين يأتون إليك.",
  "Send one request and every matching shop and dismantler on PartHub can reply with an offer.": "أرسل طلباً واحداً ويمكن لكل المحلات والكاسات المعنيّة على PartHub الردّ بعرض.",
  "Sign in to send a request": "سجّل الدخول لإرسال طلب",
  "We need an account so sellers' offers reach you and only you can accept them.": "نحتاج حساباً لتصلك عروض البائعين ولتكون وحدك من يقبلها.",
  "Sign in or create an account": "سجّل الدخول أو أنشئ حساباً",
  "🚗 Your vehicle": "🚗 سيارتك",
  "e.g. Renault": "مثلاً: Renault",
  "e.g. Clio": "مثلاً: Clio",
  "e.g. 2015": "مثلاً: 2015",
  "e.g. 1.5 dCi": "مثلاً: 1.5 dCi",
  "VIN (chassis number)": "رقم الهيكل VIN",
  "Optional, but helps sellers find the exact part. 17 characters.": "اختياري، لكنه يساعد البائعين على إيجاد القطعة بالضبط. 17 حرفاً.",
  "⚙️ The part you need": "⚙️ القطعة التي تحتاجها",
  "Part": "القطعة",
  "e.g. Alternator, front left headlight…": "مثلاً: دينامو، ضوء أمامي أيسر…",
  "Not sure": "لست متأكداً",
  "OEM / part number": "الرقم الأصلي / رقم القطعة",
  "If you know it": "إن كنت تعرفه",
  "Details": "تفاصيل",
  "Side, colour, what's wrong, anything that helps…": "الجهة، اللون، العطل، أي شيء يساعد…",
  "📍 Contact": "📍 التواصل",
  "e.g. Casablanca": "مثلاً: الدار البيضاء",
  "Phone / WhatsApp": "الهاتف / واتساب",
  "We'll message you on WhatsApp when offers arrive. Only shared with the seller whose offer you accept.": "سنراسلك على واتساب عند وصول العروض. لا يُشارك رقمك إلا مع البائع الذي تقبل عرضه.",
  "Sending…": "جارٍ الإرسال…",
  "Uploading photos…": "جارٍ رفع الصور…",
  "Send request to sellers": "أرسل الطلب إلى البائعين",
  "Free · Open for 14 days · No obligation to buy": "مجاني · مفتوح 14 يوماً · بدون التزام بالشراء",
  "View my requests →": "← عرض طلباتي",
  "Buyer account foundation": "حساب المشتري",
  "Sign in to access your account": "سجّل الدخول للوصول إلى حسابك",
  "View buyer information, orders, vehicle context, and continue the storefront flow.": "اطّلع على معلوماتك وطلباتك وسيارتك.",
  "Unlock account and order continuity.": "استعد حسابك وطلباتك.",
  "Current cart": "السلة الحالية",
  "Go to cart": "إلى السلة",
  "Review your parts before checkout.": "راجع قطعك قبل إتمام الطلب.",
  "Catalog": "الكتالوج",
  "Continue exploring inventory.": "تابع تصفّح القطع.",
  "Your buyer account": "حساب المشتري الخاص بك",
  "Central place for buyer identity, order entry points, cart context, and selected vehicle.": "معلوماتك وطلباتك وسلّتك وسيارتك في مكان واحد.",
  "View orders": "عرض الطلبات",
  "Sign out": "تسجيل الخروج",
  "Buyer profile": "ملف المشتري",
  "Not available": "غير متوفّر",
  "Role": "الدور",
  "Session state": "الجلسة",
  "Authenticated storefront buyer session active": "مسجّل الدخول كمشترٍ",
  "Update vehicle": "تغيير السيارة",
  "No vehicle selected yet.": "لم تختر سيارة بعد.",
  "Storefront state": "الحالة",
  "Orders area": "الطلبات",
  "Ready": "جاهز",
  "Orders history can plug into real buyer order APIs later.": "سجلّ الطلبات المفصّل قريباً.",
  "Account profile details can expand without touching seller/admin portals.": "ستُضاف معلومات أخرى للحساب قريباً.",
  "Vehicle context remains reusable across browsing and checkout.": "تُستعمل سيارتك في البحث وإتمام الطلب.",
  "You can add up to {n} photos.": "يمكنك إضافة {n} صور كحدّ أقصى.",
  "Upload failed": "فشل الرفع",
  "Photos": "الصور",
  "Uploading…": "جارٍ الرفع…",
  "Remove photo": "حذف الصورة",
  "Add photo": "أضف صورة",
  "Optional · up to 3 photos of the old part, its label or where it fits.": "اختياري · حتى 3 صور للقطعة القديمة أو ملصقها أو مكانها.",
  "Buyer": "مشترٍ",
  "1 offer": "عرض واحد",
  "{n} offers": "{n} عروض",
};
